const mEditionBillingProyectDetails = {
  mEditionBillingProyectDetails: {
    infoLeft: {
      title: 'INFORMACIÓN GENERAL',
      proyectType: 'Proyecto de tipo',
      activationDate: 'Fecha de activación',
      activeStudents: 'alumnos inscriptos activos',
      pendingMessages: 'mensajes pendientes'
    },
    contentTitle: 'CONTENIDO'
  }
}

export default mEditionBillingProyectDetails
